/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Star } from "lucide-react";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";

export default function Testimonials() {
  const [data, setData] = useState({ testimonials: [], ready: false });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/public/testimonials")
      .then(({ data }) => setData(data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <section className="max-w-5xl mx-auto px-6 py-12" data-testid="testimonials-page">
        <div className="text-[10px] uppercase tracking-[0.24em] font-bold text-[var(--rg-sage)] mb-3">
          Customer Stories
        </div>
        <h1 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl text-[var(--rg-text-strong)] mb-4">
          What merchants are saying about Regulens
        </h1>

        {loading ? (
          <div className="text-[var(--rg-text)]">Loading…</div>
        ) : !data.ready ? (
          <div
            className="rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] p-10 text-center"
            data-testid="testimonials-not-ready"
          >
            <p className="text-[var(--rg-text)]">
              Customer stories will appear here once we have enough merchant-approved entries.
            </p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="testimonials-grid">
            {data.testimonials.map((t) => (
              <article
                key={t.id}
                className="rounded-md border border-[var(--rg-border)] bg-[var(--rg-surface)] p-5"
                data-testid={`testimonial-${t.id}`}
              >
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className="w-4 h-4"
                      strokeWidth={1.5}
                      fill={i < t.rating ? "var(--rg-amber)" : "transparent"}
                      stroke={i < t.rating ? "var(--rg-amber)" : "var(--rg-muted)"}
                    />
                  ))}
                </div>
                <p className="text-sm text-[var(--rg-text)] leading-relaxed mb-4 italic">&ldquo;{t.body}&rdquo;</p>
                <div className="text-xs text-[var(--rg-text-strong)] font-semibold">{t.display_name}</div>
                <div className="text-[10px] text-[var(--rg-muted)] font-mono uppercase">
                  {t.created_at?.slice(0, 10)}
                </div>
              </article>
            ))}
          </div>
        )}
      </section>
    </Layout>
  );
}
